import { productShareLinkStyles } from "@insite/content-library/Components/ProductShareLink";
import getColor from "@insite/mobius/utilities/getColor";
import { isGlobalViewsWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

// Mirrors the Add to Project modal frame - see Overrides/Components/AddToListModal
// and AddToListModalStyleExtension.
productShareLinkStyles.modal = {
    size: 600,
    cssOverrides: {
        modalBody: css`
            overflow-y: visible;
        `,
        modalTitle: css`
            padding: 10px 10px 10px 20px;
            background-color: ${getColor("common.backgroundContrast")};
            border-bottom: 0;
            > h4 {
                color: ${getColor("text.main")};
            }
            button {
                border-radius: 0;
                border: none !important;
                svg {
                    height: 20px;
                }
            }
        `,
        headlineTypography: css`
            font-size: 20px;
            margin-bottom: 0;
            font-weight: ${isGlobalViewsWebsite() ? "100" : "bold"};
        `,
        modalContent: css`
            padding: 20px;
        `,
    },
};

productShareLinkStyles.cancelButton = {
    variant: "secondary",
    css: css`
        border-radius: 0px;
        padding: 10px 34px;
        background: ${COLORS.background.main};
        border: 2px solid ${COLORS.primary.base} !important;
        span[class^="TypographyStyle"] {
            color: ${COLORS.primary.base};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            opacity: 0.3;
            background: none !important;
            color: ${COLORS.primary.base};
            span[class^="TypographyStyle"] {
                color: ${COLORS.primary.base};
            }
        }
    `,
};

productShareLinkStyles.shareButton = {
    css: css`
        margin-left: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${COLORS.primary.base};
        border: 2px solid ${COLORS.primary.base};

        span[class^="TypographyStyle"] {
            color: ${COLORS.primary.contrast};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${COLORS.darkerGrey};
            span[class^="TypographyStyle"] {
                color: ${COLORS.primary.contrast};
            }
        }
    `,
};
